
import React, { useState } from 'react';
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { PlusCircle, DollarSign, Ban } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CollectionDialog } from '@/components/admin/CollectionDialog';
import { QuickBikeBlockDialog } from '@/components/admin/quick-actions/QuickBikeBlockDialog';
import { toast } from '@/components/ui/sonner';
import { addNotification } from '@/services/notificationService';

export const SidebarIntegrations: React.FC = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [showCollectionDialog, setShowCollectionDialog] = useState(false);
  const [showQuickBlockDialog, setShowQuickBlockDialog] = useState(false);
  
  const handleCreateRental = () => {
    if (isAdmin) {
      // Для администратора - перенаправляем на страницу аренд с параметром создания
      navigate('/admin/rentals?action=create');
    } else {
      // Для курьера - перенаправляем на страницу выбора тарифа
      navigate('/courier/tariff');
      
      // Показываем уведомление
      toast.info('Выбор тарифа аренды', {
        description: 'Выберите подходящий тариф аренды из списка доступных',
      });
      
      // Добавляем в систему уведомлений
      addNotification({
        title: 'Выбор тарифа аренды',
        message: 'Выберите подходящий тариф аренды для оформления',
        type: 'rental'
      });
    }
  };

  const handleQuickBlock = () => {
    console.log('SidebarIntegrations: Открытие диалога быстрой блокировки');
    setShowQuickBlockDialog(true);
  };
  
  return (
    <>
      <SidebarGroup className="mt-4">
        <SidebarGroupLabel className="px-4 text-sidebar-foreground/80 uppercase text-xs font-semibold tracking-wider">
          Быстрые действия
        </SidebarGroupLabel>
        <SidebarGroupContent>
          <div className="px-4 py-2">
            <div className="rounded-md bg-sidebar-accent/30 p-3 border border-sidebar-border shadow-sm">
              <div className="flex items-center gap-2 mb-2">
                <PlusCircle className="h-4 w-4 text-emerald-400" />
                <span className="text-sm font-medium text-white">
                  {isAdmin ? 'Действия администратора' : 'Создание аренды'}
                </span>
              </div>
              <div className="flex flex-col gap-2 mt-3">
                <Button
                  variant="elegant"
                  size="sm"
                  className="w-full rounded-md transition-all duration-300 font-medium tracking-wide hover:scale-[1.02] active:scale-[0.98]"
                  onClick={handleCreateRental}
                >
                  <PlusCircle className="h-4 w-4 mr-1" />
                  Оформить аренду
                </Button>
                
                {isAdmin && (
                  <>
                    <Button
                      variant="elegant"
                      size="sm"
                      className="w-full bg-green-700 hover:bg-green-600 rounded-md transition-all duration-300 font-medium tracking-wide hover:scale-[1.02] active:scale-[0.98]"
                      onClick={() => setShowCollectionDialog(true)}
                    >
                      <DollarSign className="h-4 w-4 mr-1" />
                      Взыскание
                    </Button>
                    
                    <Button
                      variant="elegant"
                      size="sm"
                      className="w-full bg-red-700 hover:bg-red-600 rounded-md transition-all duration-300 font-medium tracking-wide hover:scale-[1.02] active:scale-[0.98]"
                      onClick={handleQuickBlock}
                    >
                      <Ban className="h-4 w-4 mr-1" />
                      Заблокировать
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </SidebarGroupContent>
      </SidebarGroup>
      
      <CollectionDialog open={showCollectionDialog} onOpenChange={setShowCollectionDialog} />
      <QuickBikeBlockDialog open={showQuickBlockDialog} onOpenChange={setShowQuickBlockDialog} />
    </>
  );
};
